import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PdfReaderPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { pdfUrl, fileName } = location.state || {};

  if (!pdfUrl) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center vh-100">
        <p>Nenhum PDF selecionado.</p>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Voltar
        </button>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column" style={{ height: "100vh" }}>
      <iframe
        title={fileName || "PDF Reader"}
        src={pdfUrl}
        width="100%"
        style={{ flex: 1, border: "none" }}
      />
    </div>
  );
};

export default PdfReaderPage;
